var _style, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 216",
    style: {
      enableBackground: "new 0 0 350 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "tarjeta",
    viewBox: "-153.75 -109.5 307.5 219"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.55,31.5c-0.59,0.62-1.18,1.24-1.78,1.85c-1.06,1.06-2.12,2.12-3.22,3.21c6.21,6.44,9.49,14.08,9.5,23.02 c0.01,8.94-3.26,16.59-9.42,22.98c1.69,1.68,3.37,3.36,5.07,5.05c1.62-1.6,3.12-3.39,4.46-5.32c3.91-5.62,6.29-11.84,6.91-18.65 c1.11-12.27-2.63-22.91-11.15-31.85c-0.09-0.09-0.16-0.19-0.24-0.29C114.63,31.5,114.59,31.5,114.55,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.45,46.79c3.41,3.56,5.23,7.82,5.23,12.81c0,4.99-1.84,9.25-5.25,12.81c1.69,1.69,3.36,3.35,5.03,5.02 c9.62-9.07,10.17-25.88,0.03-35.69C102.81,43.41,101.15,45.08,99.45,46.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.28,62.25c1.69,1.68,3.37,3.36,5.05,5.03c4.36-4.17,4.14-11.51-0.03-15.4c-1.67,1.67-3.34,3.33-5.03,5.02 C90.67,58.67,90.69,60.48,89.28,62.25z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.14-108.5h-248.29c-15.8,0-28.61,12.81-28.61,28.61V79.89c0,15.8,12.81,28.61,28.61,28.61h248.29 c15.8,0,28.61-12.81,28.61-28.61V-79.89C152.75-95.69,139.94-108.5,124.14-108.5z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tarjeta",
    width: 307.5,
    height: 219,
    id: "XMLID_00000013873217258622016230000006432692273077353867_",
    x: -153.75,
    y: -109.5,
    transform: "matrix(0.5522 -0.2405 -0.2401 -0.5513 175.25 108.25)",
    style: {
      overflow: "visible"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.7b99edb8166bf33616c29171938b2381.svg";
export { ForwardRef as ReactComponent };